/** Interrupteur — même API que l’ancienne case, partout en Paramètres. */
import "./checkField.css";

type CheckFieldProps = {
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
};

export function CheckField({ label, checked, onChange, disabled }: CheckFieldProps) {
  return (
    <label className={`fx-toggle${disabled ? " is-off" : ""}`}>
      <span className="fx-toggle__text">{label}</span>
      <span className="fx-toggle__switch">
        <input
          className="fx-toggle__input"
          type="checkbox"
          role="switch"
          checked={checked}
          disabled={disabled}
          aria-checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="fx-toggle__track" aria-hidden />
      </span>
    </label>
  );
}
